var ScreenWrapper = Vue.extend({
    template:  '   <div class="p-loader full" v-if="isLoading || isLock() || message">'+
 '       <div class="p-loader_message" v-if="isLock() || message" v-html="dispMessage()"></div>'+
 '       <div class="p-loader_icon c-loader" v-if="isLoading"></div>'+
 '   </div>',
    props: {
        isLoading: Number,
        limit: Object,
        message: String
    },
    computed: {},
    methods: {
        isLock: function() {
            if (!this.limit) return false;
            if (this.limit.analyzeCheck) {
              return true;
            }
            if (this.limit.analyzeNumber || this.limit.analyzeCapacity) {
                return true;
            }
            const targetCode = getRequestPram('target_code');
            const menus = JSON.parse(localStorage.getItem('local_menus'));
            if (targetCode === 'IF00009' && this.limit.trendSetting === 0) {
                return true;
            }
            if (menus[targetCode].show === 0) {
                return true;
            }
            return false;
        },
        dispMessage: function() {
            var msg = [];
            var out = '';
            if (!this.message) {
                if (this.limit) {
                    if (this.limit.analyzeNumber) {
                        msg.push('保存できる分析結果が上限を超えています。');
                    }
                    if (this.limit.analyzeCapacity) {
                        msg.push('実行できる分析従量が上限を超えています。');
                    }
                    if (this.limit.analyzeCheck) {
                      msg.push(this.limit.analyzeCheckMsg);
                    } else {
                      const targetCode = getRequestPram('target_code');
                      const menus = JSON.parse(localStorage.getItem('local_menus'));
                      if (menus[targetCode].show === 0 || (targetCode === 'IF00009' && this.limit.trendSetting === 0)) {
                          msg.push(`${menus[targetCode].title}は未契約の為、ご利用いただけません。`);
                          msg.push('本分析はオプションの為、別途ご契約が必要となります。');
                          msg.push('詳細につきましてはサポートデスクまたは、営業担当までお問い合わせください。');
                      }
                    }
                    if (msg.length) {
                        out = msg.join('<br>');
                    }
                }
            } else {
                out = this.message;
            }
            return out;
        }
    }
});
export default ScreenWrapper;
